export const CLIENT_CATEGORIES = [
  { key: "gst_monthly", label: "GST Monthly", short: "GST-M" },
  { key: "gst_quarterly", label: "GST Quarterly", short: "GST-Q" },
  { key: "itr", label: "ITR Clients", short: "ITR" },
  { key: "other", label: "Other Services", short: "Other" },
];

export const CATEGORY_LABEL = { ...Object.fromEntries(CLIENT_CATEGORIES.map(c => [c.key, c.label])), tds: "TDS Clients" };
export const CATEGORY_SHORT = Object.fromEntries(CLIENT_CATEGORIES.map(c => [c.key, c.short]));
